import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography, Stack, Divider } from '@mui/material';
import { currencyFormatter } from '@utils/Numbers';

interface ModalUberQuoteProps {
    isOpen: boolean;
    onClose: () => void;
    onConfirm: () => void;
    quoteData: any;
    isLoading: boolean;
}

export const ModalUberQuote: React.FC<ModalUberQuoteProps> = ({ isOpen, onClose, onConfirm, quoteData, isLoading }) => {
    if (!quoteData) return null;

    return (
        <Dialog open={isOpen} onClose={onClose} maxWidth="sm" fullWidth>
            <DialogTitle fontWeight={600}>Cotización de Uber Direct</DialogTitle>
            <DialogContent>
                <Stack spacing={2} mt={1}>
                    <Typography variant="body1">
                        Verifica los datos del viaje antes de solicitar el repartidor.
                    </Typography>

                    <Stack component="div" bgcolor="#f5f5f5" p={2} borderRadius={2} spacing={1}>
                        <Stack direction="row" justifyContent="space-between">
                            <Typography color="text.secondary">Costo del envío:</Typography>
                            <Typography fontWeight={600}>{currencyFormatter(quoteData.fee / 100)}</Typography>
                        </Stack>
                        <Divider />
                        <Stack direction="row" justifyContent="space-between">
                            <Typography color="text.secondary">Moneda:</Typography>
                            <Typography>{quoteData.currency_type}</Typography>
                        </Stack>
                        <Stack direction="row" justifyContent="space-between">
                            <Typography color="text.secondary">Tiempo est. llegada (Dropoff):</Typography>
                            <Typography>{new Date(quoteData.dropoff_eta).toLocaleTimeString()}</Typography>
                        </Stack>
                    </Stack>
                    <Typography variant="caption" color="error">
                        Esta cotización expira:{' '}
                        {quoteData.expires_at ? new Date(quoteData.expires_at).toLocaleTimeString() : 'Sin expiración'}
                    </Typography>
                </Stack>
            </DialogContent>
            <DialogActions sx={{ p: 2 }}>
                <Button onClick={onClose} color="inherit" disabled={isLoading}>
                    Cancelar
                </Button>
                <Button onClick={onConfirm} variant="contained" color="primary" disabled={isLoading}>
                    Confirmar Envío
                </Button>
            </DialogActions>
        </Dialog>
    );
};
